const msalErrors = [
    {
      code: 'interaction_required',
      description: 'User interaction is required to complete the login process,',
    },
    {
      code: 'login_required',
      description: 'The user must log in to continue. Please prompt the user to sign in,',
    },
    {
      code: 'user_cancelled',
      description: 'The user canceled the login process,',
    },
    {
      code: 'network_error',
      description: 'A network error occurred. Please check your internet connection and try again,',
    },
    {
      code: 'server_temporarily_unavailable',
      description: 'The authentication server is temporarily unavailable. Please try again later,',
    },
    {
      code: 'invalid_grant',
      description: 'The token is invalid or has expired,',
    },
    {
      code: 'invalid_client',
      description: 'Invalid client configuration. Please check your Client ID or redirect URI,',
    },
    {
      code: 'popup_window_error',
      description: 'The login popup could not be opened. Please allow popups in your browser,',
    },
    {
      code: 'token_renewal_error',
      description: 'Failed to renew the token. Please reauthenticate,',
    },
    {
      code: 'access_denied',
      description: 'Access was denied by the user or the resource,',
    },
    {
        code: 'interaction_in_progress',
        description: 'Interaction is currently in progress. Please ensure that this interaction has been completed,',
      },
    {
      code: 'unknown_error',
      description: 'An unexpected error occurred. Please try again later,',
    },
  ];

  export const getMsalErrorMsg = (errorCode) => {
    const error = msalErrors.find((e) => e.code === errorCode);
    return error ? error.description : 'An unknown error occurred.';
  }
  
  export default msalErrors;
  